import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledHeader = styled.header`
  margin-top: ${themeGet('transparentHeader.transparentHeaderMargin')};
  padding-top: ${themeGet('transparentHeader.transparentHeaderPadding')};
  background-image: linear-gradient(
    to bottom,
    ${themeGet('color.colorGrayBlue20')},
    ${themeGet('color.colorGrayBlue30')}
  );
  text-align: center;

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 0;
    padding-top: ${themeGet('scale.scaleUp10')};
  }

  h1 {
    margin-bottom: ${themeGet('scale.scaleDown03')};
  }

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    h1 {
      font-size: ${themeGet('scale.scaleUp05')};
    }

    .btn {
      display: none;
    }
  }

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    h1 {
      font-size: ${themeGet('scale.scaleUp03')};
    }
  }
`;

export const StyledText = styled.p`
  margin-top: ${themeGet('scale.scaleUp03')};
  margin-bottom: ${themeGet('scale.scaleUp08')};
  font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: ${themeGet('scale.scaleDown01')};
  font-weight: ${themeGet('fontWeight.fontWeightMedium')};
  color: ${themeGet('color.colorGrayBlue70')};

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    display: none;
  }
`;

export const StyledSubHeaderText = styled.p`
  margin-bottom: ${themeGet('scale.scaleUp03')};
  font-size: ${themeGet('scale.scaleUp02')};
  color: ${themeGet('color.colorGrayBlue70')};

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: ${themeGet('scale.scaleUp05')};
    font-size: ${themeGet('scale.scaleUp01')};
  }

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    font-size: ${themeGet('scale.scaleDown01')};
  }
`;
